module.exports = __webpack_public_path__ + "assets/8bb123a7819eb9c6da69059110dfef3a.png";